import { create } from "zustand";
import { FiltersFormT } from "../app/Bookings/FiltersForm/filters.schema";
import { Booking } from "../app/Bookings/model";

export type BookingsStore = {
  filters: FiltersFormT | null;
  setFilters: (filters: FiltersFormT | null) => void;
  booking: Booking | null;
  setBooking: (booking: Booking) => void
};

export const useBookingsStore = create<BookingsStore>((set) => ({
  filters: null,
  setFilters: (filters) => set({ filters }),
  booking: null,
  setBooking: (booking: Booking) => {
    return set({ booking })
  }
}));
